import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Card, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import EnvironmentData from "../components/EnvironmentData";
import { getSingleResult } from "../../../actions/analysis";

export const PVEnvironment = (props) => {
  const tabs = ["Data"];
  const [activeTab, setActiveTab] = useState("Data");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (props.PV_environmental_impact === undefined) {
      props.getSingleResult(props.analysis.id, ["PV_environmental_impact"]);
    }
  }, []);

  return (
    <div>
      {/* undefined manages cases created without run, null manages cases with a run but without a True on either PV_run or WT_run */}
      {props.PV_environmental_impact === undefined ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <i className="fa fa-spinner fa-spin fa-3x"></i>
          </div>
        </div>
      ) : props.PV_environmental_impact === null ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          This simulation was not run for Photovoltaic evaluation
        </div>
      ) : (
        <div style={{ padding: 20 }}>
          <h3 style={{ marginTop: 20, marginBottom: 0 }}>PV Environment</h3>
          <p style={{ marginTop: 2, marginBottom: 20 }}>
            Environmental benefits generated by Photovoltaic plant
          </p>
          <div>
            <React.Fragment>
              <Nav
                tabs
                style={{
                  cursor: "pointer",
                  width: "100%",
                  border: "none",
                }}
              >
                {tabs.map((tab) => (
                  <NavItem key={tab} style={{ width: `${100 / tabs.length}%` }}>
                    <NavLink
                      className={classnames({ active: activeTab === tab })}
                      onClick={() => {
                        toggle(tab);
                      }}
                      style={
                        activeTab === tab
                          ? {
                              color: "#1F5CDD",
                              padding: 11,
                              textAlign: "center",
                            }
                          : { color: "black", padding: 11, textAlign: "center" }
                      }
                    >
                      {tab}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent
                activeTab={activeTab}
                style={{
                  border: "1px solid #DFDFDF",
                  borderRadius: 3,
                  backgroundColor: "white",
                }}
              >
                {tabs.map((tab) => {
                  // render only the active tab --> otherwise it renders all tabs
                  if (tab === activeTab) {
                    return (
                      <TabPane tabId={tab} key={tab}>
                        {tab === "Data" ? (
                          <EnvironmentData
                            data={props.PV_environmental_impact}
                            type_short={"PV"}
                          ></EnvironmentData>
                        ) : null}
                      </TabPane>
                    );
                  }
                })}
              </TabContent>
            </React.Fragment>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  PV_environmental_impact: state.analysis.PV_environmental_impact,
  analysis: state.analysis,
});

export default connect(mapStateToProps, { getSingleResult })(PVEnvironment);
